var exports = {
  "kL": "x127c5a35--e97131--container",
  "Vd": "x127c5a35--e97131--slideUp",
  "Xn": "x127c5a35--e97131--fadeOut",
  "Qs": "x127c5a35--e97131--content",
};

module.exports = exports;
